// Base content structure for image-based ratings
const baseRatingContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "rating",
    file: {},
    isUpdated: false,
  },
  translation: { input: "", flag: false, isUpdated: false },
};

// Helper function to create a rating entry
const createRatingEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseRatingContent,
    data: {
      ...baseRatingContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Rating entries
const ratingEntries = [
  { title: "Smiley Image 1", key: "smileyImage1" },
  { title: "Smiley Image 2", key: "smileyImage2" },
  { title: "Smiley Image 3", key: "smileyImage3" },
  { title: "Smiley Image 4", key: "smileyImage4" },
  { title: "Smiley Image 5", key: "smileyImage5" },
];

// Generate ratings array
const ratings = ratingEntries.map(({ title, key }) => createRatingEntry(title, key));

export { ratings };
